import React from "react";
import styles from "./Subtitle.module.scss";

export interface ISubtitle {
  className?: string;
  text?: string | React.ReactNode;
}

export const Subtitle: React.FC<ISubtitle> = ({ className, text }) => {
  return <h3 className={`${styles.subtitle} ${className}`}>{text}</h3>;
};
